import axios from "axios";
import { IPublicClientApplication } from "@azure/msal-browser";
import { apiRequest } from "../authConfig";

const API_URL = `${process.env.REACT_APP_API_BASE_URL}/api`;

export interface CoverSheetDetail {
  id: number;
  warehouse: string;
  branch: string;
  inventoryID: string;
  vendorID: string;
  freightVendorID: string;
  loads: number;
  receivedQty: number;
  uom: string;
  scenario: number;
  orderDate: string;
  batchId: string;
  createdTimestamp: string;
}

export interface CoverSheet {
  batchId: string;
  data: CoverSheetDetail[];
}

export const getCoverSheet = async (
  instance: IPublicClientApplication,
  account: any,
  batchId: string,
  scenario: number,
): Promise<CoverSheet> => {
  const response = await instance.acquireTokenSilent({
    ...apiRequest,
    account: account,
  });
  const config = {
    headers: { Authorization: `Bearer ${response.accessToken}` },
    params: { batchId, scenario },
  };
  try {
    const apiResponse = await axios.get<CoverSheet>(
      `${API_URL}/coversheet`,
      config,
    );
    return apiResponse.data;
  } catch (error) {
    console.error(`Error fetching cover sheet:`, error);
    throw error;
  }
};

export const deleteCoverSheetDetails = async (
  instance: IPublicClientApplication,
  account: any,
  ids: number[],
): Promise<void> => {
  const response = await instance.acquireTokenSilent({
    ...apiRequest,
    account: account,
  });
  const config = {
    headers: { Authorization: `Bearer ${response.accessToken}` },
  };
  try {
    await Promise.all(ids.map(id => axios.delete(`${API_URL}/coversheet/${id}`, config)));
  } catch (error) {
    console.error(`Error deleting cover sheet details:`, error);
    throw error;
  }
};

export const upsertCoverSheetDetails = async (
  instance: IPublicClientApplication,
  account: any,
  coverSheetDetails: CoverSheetDetail[],
): Promise<void> => {
    const response = await instance.acquireTokenSilent({
      ...apiRequest,
      account: account,
    });
    const config = {
      headers: { Authorization: `Bearer ${response.accessToken}` },
    };
    try {
        await axios.post(`${API_URL}/coversheet`, coverSheetDetails, config);
    } catch (error) {
        console.error(`Error upserting cover sheet details:`, error);
        throw error;
    }
};
